import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

@Injectable({ providedIn: 'root' })
export class InstantErrorStateMatcher extends ErrorStateMatcher {
  isErrorState(control: AbstractControl | null): boolean {
    return (control?.invalid && (control.dirty || control.touched)) ?? false;
  }
}
